/* Palsora: soft fades between product-page sections. Where one section's background colour (cream, beige, white)
   meets a different one, the lower section starts with a gradient from the colour above, so the change blends
   instead of cutting. Sections with a photo background are left as they are. */
(function () {
  if (window.__palsFade) return; window.__palsFade = true;
  function parse(c) { var m = c && c.match(/rgba?\(([^)]+)\)/); if (!m) return null; var p = m[1].split(',').map(function (x) { return parseFloat(x); }); return { r: p[0], g: p[1], b: p[2], a: p.length > 3 ? p[3] : 1 }; }
  function painted(el) {
    // the element that paints this section's background: the section or one of its first few descendants that spans its width
    var w = el.getBoundingClientRect().width, cur = el;
    for (var d = 0; d < 4 && cur; d++) {
      var cs = getComputedStyle(cur), c = parse(cs.backgroundColor);
      if (cs.backgroundImage && cs.backgroundImage !== 'none' && !cur.hasAttribute('data-pals-fade')) return { el: cur, photo: true };
      if (c && c.a > 0.9 && cur.getBoundingClientRect().width >= w - 2) return { el: cur, c: c, css: cs.backgroundColor };
      var nx = null;
      for (var k = 0; k < cur.children.length; k++) { var ch = cur.children[k]; if (/^(LINK|SCRIPT|STYLE|TEMPLATE|NOSCRIPT)$/.test(ch.tagName)) continue; if (ch.offsetHeight > 20) { nx = ch; break; } }
      cur = nx;
    }
    return null;
  }
  function light(c) { return c && (0.2126 * c.r + 0.7152 * c.g + 0.0722 * c.b) / 255 > 0.8; }
  function run() {
    var main = document.querySelector('main') || document.body;
    var page = getComputedStyle(document.body).backgroundColor;
    var secs = Array.prototype.filter.call(main.children, function (s) { return s.offsetHeight > 40 && getComputedStyle(s).display !== 'none'; });
    var prev = null;
    secs.forEach(function (s) {
      var p = painted(s) || { el: s, css: page, c: parse(page), page: true };
      var ok = prev && !p.photo && !prev.photo && p.css !== prev.css && light(p.c) && light(prev.c);
      if (ok && !p.page) {
        var h = window.innerWidth < 750 ? 56 : 88;
        p.el.style.backgroundImage = 'linear-gradient(to bottom, ' + prev.css + ' 0, ' + p.css + ' ' + h + 'px)';
        p.el.setAttribute('data-pals-fade', '');
      } else if (ok && p.page && !prev.page) {
        // a page-coloured section under a coloured one: fade on its own wrapper
        var hh = window.innerWidth < 750 ? 56 : 88;
        s.style.backgroundColor = p.css;
        s.style.backgroundImage = 'linear-gradient(to bottom, ' + prev.css + ' 0, ' + p.css + ' ' + hh + 'px)';
        s.setAttribute('data-pals-fade', '');
      }
      prev = p;
    });
  }
  function go() { run(); setTimeout(run, 1200); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();
